export const getShortName = function (string, len) {
  string = String(string);
  if (len >= string.length) return string;
  return string.split(" ").slice(0, len).join(" ");
};
